






import Vue from "vue";
export default Vue.extend({
    data() {
        return {
            topToBottom: false,
            bottomToTop: false,
            ro: null,
        };
    },
    methods: {
        getTableWrapperInParent() {
            if (this.$parent && this.$parent.$el) {
                let parent = this.$parent;
                while (!parent.$el.querySelector(".v-data-table__wrapper")) {
                    parent = parent.$parent;
                }
                return parent;
            }

            return null;
        },
        onTopToBottomScroll(e) {
            if (!this.bottomToTop) {
                this.topToBottom = true;
                // console.log("parent", parent);
                // console.log("parent.$el.querySelector('.v-data-table__wrapper')", parent.$el.querySelector(".v-data-table__wrapper"));
                this.getTableWrapperInParent().$el.querySelector(".v-data-table__wrapper").scrollLeft = this.$refs.HScrollbar.scrollLeft;
                this.topToBottom = false;
            }
        },
        onBottomToTopScroll(e) {
            if (!this.topToBottom) {
                this.bottomToTop = true;
                this.$refs.HScrollbar.scrollLeft = this.getTableWrapperInParent().$el.querySelector(".v-data-table__wrapper").scrollLeft;
                this.bottomToTop = false;
            }
        },
        attachEvent() {
            if (this.getTableWrapperInParent()) {
                const domElement = this.getTableWrapperInParent().$el.querySelector(".v-data-table__wrapper");

                domElement.addEventListener("scroll", this.onBottomToTopScroll);
                this.ro = new ResizeObserver((e) => {
                    const parentTableScrollWidth = this.getTableWrapperInParent().$el.querySelector("table").scrollWidth;
                    // console.log("sync width, parentTableScrollWidth", parentTableScrollWidth);

                    if (parentTableScrollWidth) {
                        this.$refs.innerHSCrollbar.style["width"] = parentTableScrollWidth + "px";
                    } else {
                        this.$refs.innerHSCrollbar.style["width"] = "1000px";
                    }
                });
                this.ro.observe(domElement);
            }
        },
    },
    mounted() {
        setTimeout(() => {
            this.attachEvent();
        }, 100);
    },
    beforeDestroy() {
        this.ro.disconnect();
    },
});
